import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  SidebarWrapper,
  SidebarEmail,
  ButtonText,
  SideButton,
  SidebarWhitespace,
} from '@layout/Sidebar';
import onClickOutside from 'react-onclickoutside';
import { Whitespace } from '@layout';
import { NavButton, Icon, Toggle } from '@atoms';

const buttonStyle = { marginBottom: 0, paddingBottom: '22px' };
const iconStyle = { width: '24px', height: '24px', minHeight: '24px', minWidth: '24px' };
const triangleIconStyle = { marginLeft: '95px', transform: 'rotate(180deg)' };

const deleteOldConferencesMessage = {
  true: 'Please enter the reason to CANCEL deleting old conferences?',
  false: 'Are you sure you want to RESUME deleting old conferences?',
};

export class SidebarComponent extends PureComponent {
  static propTypes = {
    email: PropTypes.string,
    isSuperAdmin: PropTypes.bool.isRequired,
    logoutOnClick: PropTypes.func.isRequired,
    pushFromSidebar: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    openSidebar: PropTypes.func.isRequired,
    closeSidebar: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    isSidebarVisible: PropTypes.bool,
  };

  goTo = (route) => (e) => {
    e.stopPropagation();
    this.props.pushFromSidebar({ route, active: this.props.active });
  };

  handleClickOutside = () => {
    const { active, closeSidebar } = this.props;
    if (active) this.props.closeSidebar(active);
  };

  handleClickDeletingOldConferences = (e) => {
    e.stopPropagation();
    const { shouldDeleteOldConferences, toggleDeletingOldConferences } = this.props;
    const reason = shouldDeleteOldConferences
      ? window.prompt(deleteOldConferencesMessage[shouldDeleteOldConferences])
      : window.confirm(deleteOldConferencesMessage[shouldDeleteOldConferences]);
    if (reason) {
      toggleDeletingOldConferences(!shouldDeleteOldConferences, reason);
    }
  };

  toggleSidebar = () => {
    const { active, closeSidebar, openSidebar } = this.props;
    if (active) closeSidebar(active);
    else openSidebar();
  };

  showButtonNameIfActive = (name) =>
    this.props.active && <ButtonText> {name} </ButtonText>;

  isUnderAdminPath = () => {
    return ['/admin', '/settings', '/blocked-attendees', '/organizations'].some(
      (p) => p === this.props.path,
    );
  };

  render() {
    const {
      isSuperAdmin,
      logoutOnClick,
      shouldDeleteOldConferences,
      active,
      email,
      isSidebarVisible = true,
    } = this.props;

    const {
      goTo,
      toggleSidebar,
      showButtonNameIfActive,
      handleClickDeletingOldConferences,
      isUnderAdminPath,
    } = this;

    return isSidebarVisible ? (
      <SidebarWrapper id="sidebar" active={active} onClick={toggleSidebar}>
        {active && <SidebarEmail>{email}</SidebarEmail>}

        <NavButton style={buttonStyle} to="/" onClick={goTo('/')} title="Dashboard">
          <Icon name="calendar" activeOn="/" style={iconStyle} />
          {showButtonNameIfActive('Dashboard')}
        </NavButton>
        <NavButton
          style={buttonStyle}
          to="/conference/new"
          onClick={goTo('/conference/new')}
          title="Create Conference"
        >
          <Icon name="phone" activeOn="/conference/new" style={iconStyle} />
          {showButtonNameIfActive('Schedule Conference Call')}
        </NavButton>
        <NavButton
          style={buttonStyle}
          to="/transcript/new"
          onClick={goTo('/transcript/new')}
          title="Create Transcript"
        >
          <Icon name="edit" activeOn="/transcript/new" style={iconStyle} />
          {showButtonNameIfActive('Order Transcription')}
        </NavButton>
        <SideButton
          style={buttonStyle}
          active={isUnderAdminPath}
          onClick={toggleSidebar}
          title="Admin"
        >
          <Icon name="settings" style={iconStyle} active={isUnderAdminPath} />
          {showButtonNameIfActive(
            <span>
              Admin
              <Icon style={triangleIconStyle} name="triangle" />
            </span>,
          )}
        </SideButton>
        {active && (
          <Fragment>
            {isSuperAdmin && (
              <NavButton
                style={buttonStyle}
                to="/organizations"
                onClick={goTo('/organizations')}
                title="Organizations"
              >
                <SidebarWhitespace />
                {showButtonNameIfActive('Clients')}
              </NavButton>
            )}
            <NavButton
              style={buttonStyle}
              to="/settings"
              onClick={goTo('/settings')}
              title="Settings"
            >
              <SidebarWhitespace />
              {showButtonNameIfActive('User Account')}
            </NavButton>
            <NavButton
              style={buttonStyle}
              to="/blocked-attendees"
              onClick={goTo('/blocked-attendees')}
              title="Blocked Attendees"
            >
              <SidebarWhitespace />
              {showButtonNameIfActive('Blocked Attendees')}
            </NavButton>
            {isSuperAdmin && (
              <NavButton
                style={buttonStyle}
                to="/admin"
                onClick={goTo('/admin')}
                title="Admin"
              >
                <SidebarWhitespace />
                {showButtonNameIfActive('Admin Panel')}
              </NavButton>
            )}
          </Fragment>
        )}
        <NavButton
          style={buttonStyle}
          to="/phone-numbers"
          onClick={goTo('/phone-numbers')}
          title="Phone Numbers"
        >
          <Icon name="phoneBook" activeOn="/phone-numbers" style={iconStyle} />
          {showButtonNameIfActive('Phone Numbers')}
        </NavButton>
        <Whitespace size="1.5em" />
        {isSuperAdmin && active && (
          <Fragment>
            <Toggle
              id="should-delete-old-conferences"
              label="Suspend Deletion of Transcription"
              toggled={shouldDeleteOldConferences}
              onClick={handleClickDeletingOldConferences}
            />
            <Whitespace size="1.5em" />
          </Fragment>
        )}
        <NavButton style={buttonStyle} onClick={logoutOnClick} title="Log out">
          <Icon name="logout" style={iconStyle} />
          {showButtonNameIfActive('Log Out')}
        </NavButton>
      </SidebarWrapper>
    ) : null;
  }
}
export const Sidebar = onClickOutside(SidebarComponent);



// WEBPACK FOOTER //
// ./components/organisms/Sidebar/Sidebar.js